// helper to remove a global reference, which might not be possible via delete alone, depending on the implementation
// of the reference, in that case, fall back to setting the property to undefined
function removeGlobalReference(name){
	name = ''+name;

	try {
		if( !(delete window[name]) ){
			window[name] = undefined;
		}
	} catch(ex) {
		window[name] = undefined;
	}
}

// keep these references, they might be directly referenced by other plugins
export let jQuery = window.$;
export let lodash = window._;
